'use strict';
var parent = require('../../stable/disposable-stack');
require('../../modules/esnext.suppressed-error.constructor');
require('../../modules/esnext.disposable-stack.constructor');
require('../../modules/esnext.iterator.dispose');

module.exports = parent;
